import { Injectable } from '@angular/core';
import { generateClient } from 'aws-amplify/api';
import * as queries from '@graphql/queries';
import * as mutations from '@graphql/mutations';
import {
    Brand,
    CreateBrandInput,
    UpdateBrandInput
} from '@app/core/services/api/API.service';
@Injectable({
    providedIn: 'root'
})
export class BrandService {
    private amplifyClient = generateClient();
    constructor() {}

    async listBrands(): Promise<Brand[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.listBrands
                })
            ).data.listBrands.items;
            if (data) return data as Brand[];
        } catch (error) {
            console.error('Error finding Brand:', error);
            return null;
        }
    }
    async createBrand(input: CreateBrandInput): Promise<Brand> {
        try {
            const date = (
                await this.amplifyClient.graphql({
                    query: mutations.createBrand,
                    variables: {
                        input
                    }
                })
            ).data.createBrand;
            if (date) return date as Brand;
        } catch (error) {
            console.error('Error creating Brand:', error);
            return null;
        }
    }

    async UpdateBrand(input: UpdateBrandInput): Promise<Brand> {
        try {
            const date = (
                await this.amplifyClient.graphql({
                    query: mutations.updateBrand,
                    variables: {
                        input
                    }
                })
            ).data.updateBrand;
            if (date) return date as Brand;
        } catch (error) {
            console.error('Error creating Brand:', error);
            return null;
        }
    }
}
